import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './Popover.module.css';
import clx from './clx';

export default function Popover({ anchorRef, open, onClose, align = 'left', width, minWidth, className, children }) {
  const panelRef = useRef(null);
  const [coords, setCoords] = useState(null);

  useEffect(() => {
    if (!open) return;
    const reposition = () => {
      const r = anchorRef.current?.getBoundingClientRect();
      if (!r) return;
      setCoords({
        top: r.bottom + 6,
        left: align === 'right' ? undefined : r.left,
        right: align === 'right' ? window.innerWidth - r.right : undefined,
        minWidth: minWidth ?? r.width,
      });
    };
    reposition();
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    return () => {
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
    };
  }, [open, align, minWidth, anchorRef]);

  useEffect(() => {
    if (!open) return;
    const onDocMouseDown = (e) => {
      if (anchorRef.current?.contains(e.target)) return;
      if (panelRef.current?.contains(e.target)) return;
      onClose();
    };
    const onKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', onDocMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose, anchorRef]);

  if (!open || !coords) return null;

  return ReactDOM.createPortal(
    <div
      ref={panelRef}
      className={clx(styles.panel, className)}
      style={{ top: coords.top, left: coords.left, right: coords.right, width, minWidth: coords.minWidth }}
    >
      {children}
    </div>,
    document.body
  );
}
